const dev = process.env.NODE_ENV === "development";

export const log = {
  warn: (...args) => { if (dev) console.warn(...args); },
  error: (...args) => { if (dev) console.error(...args); },
};
